// extracted by mini-css-extract-plugin
export default {"cart-number-notification":"Notification_cart-number-notification__a7DFe"};